import { render, staticRenderFns } from "./VocabularyBox.vue?vue&type=template&id=5e73c3b3&scoped=true&"
import script from "./VocabularyBox.vue?vue&type=script&lang=js&"
export * from "./VocabularyBox.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyBox.vue?vue&type=style&index=0&id=5e73c3b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73c3b3",
  null
  
)

component.options.__file = "VocabularyBox.vue"
export default component.exports